import { useSearchParams, Navigate, Outlet } from "react-router-dom"

import useLoginCookie from "shared/model/useLoginCookie"
import useRoleCookie from "shared/model/useRoleCookie"
import { ROLE_EVENT_ADMIN, ROLE_FRANCHISE_MANAGER, ROLE_STORE_ADMIN, ROLE_SITE_ADMIN, ROLE_STORE_MANAGER, ROLE_SUPER_ADMIN, ROLE_MARKETING_ADMIN } from "shared/constant/lookup/role"
import { useEffect } from "react"

const defaultLoginPage = "/login/manager"

// 로그인 Cookie가 존재하지 않는다면 로그인 페이지로 Redirect
export const PrivateRoute = () => {
    const [loginCookie] = useLoginCookie()

    return loginCookie
        ? <Outlet />
        : <Navigate to={defaultLoginPage} replace />
}

// 로그인 Cookie가 존재한다면 메인 페이지로 Redirect
export const PublicRoute = () => {
    const [loginCookie] = useLoginCookie()

    return loginCookie
        ? <Navigate to="/" replace />
        : <Outlet />
}

// 허용된 권한이 아니라면 메인 페이지로 Redirect
export const ProtectRoute = ({ permissionRoleList }) => {
    const [roleCookie] = useRoleCookie()

    return permissionRoleList.includes(roleCookie)
        ? <Outlet />
        : <Navigate to="/" replace />
}

// page 값이 없다면 page query를 붙여 redirect
export const InitPageQueryRouter = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const pageIndex = parseInt(searchParams.get("page"))

    useEffect(() => {
        if (!pageIndex) {
            searchParams.set("page", "1")
            setSearchParams(searchParams, { "replace": true })
        }
    }, [pageIndex])

    return pageIndex
        ? <Outlet />
        : null
}

// proGrade 값이 없다면 proGrade query를 붙여 redirect
export const InitProGradeQueryRouter = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const proValue = searchParams.get("proGrade")

    useEffect(() => {
        if (!proValue) {
            searchParams.set("proGrade", "rookie")
            setSearchParams(searchParams, { "replace": true })
        }
    }, [proValue])

    return proValue
        ? <Outlet />
        : null
}

// 로그인 권한에 따라 초기 페이지로 Redirect
export const StartPageRouter = () => {
    const [roleCookie] = useRoleCookie()

    const defaultPage = {
        [ROLE_SUPER_ADMIN]: "/user",
        [ROLE_EVENT_ADMIN]: "/user",
        [ROLE_STORE_ADMIN]: "/manager/franchise",
        [ROLE_SITE_ADMIN]: "/event",
        [ROLE_MARKETING_ADMIN]: "/notice",
        [ROLE_FRANCHISE_MANAGER]: "/manager/my",
        [ROLE_STORE_MANAGER]: "/store/my"
    }

    return !roleCookie
        ? <Navigate to={defaultLoginPage} replace />
        : <Navigate to={defaultPage[roleCookie]} replace />
}